'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnTypeStyle = {
  fontWeight: 'bold',
  textTransform: 'uppercase'
};

var prominentRowStyle = {
  color: '#e03997',
  fontWeight: 'bold',
  fontSize: 18
};

var pinkColor = {
  color: '#e03997'
};

var generalGridStyle = {
  //   color: 'white',
};

var SummaryTable = function SummaryTable(_ref) {
  var rows = _ref.rows,
      totals = _ref.totals;

  var values = _lodash2.default.values(rows);
  var totalInfluencers = _lodash2.default.size(values);
  var authorised = _lodash2.default.filter(values, 'instagramAuthorised');
  var havePosted = _lodash2.default.filter(values, 'hasPosts');
  var authorisedCount = _lodash2.default.size(authorised);
  var notAuthorisedCount = _lodash2.default.subtract(totalInfluencers, authorisedCount);
  var havePostedCount = _lodash2.default.size(havePosted);
  var postsCount = _lodash2.default.sumBy(values, function (row) {
    var images = _lodash2.default.get(row, 'trackedAssetsStats.instagram.images', 0);
    var carousels = _lodash2.default.get(row, 'trackedAssetsStats.instagram.carousels', 0);
    return _lodash2.default.add(images, carousels);
  });
  var storiesCount = _lodash2.default.sumBy(values, function (row) {
    return _lodash2.default.get(row, 'trackedAssetsStats.instagram.stories', 0);
  });
  var videosCount = _lodash2.default.sumBy(values, function (row) {
    return _lodash2.default.get(row, 'trackedAssetsStats.instagram.videos', 0);
  });
  var igtvCount = _lodash2.default.sumBy(values, function (row) {
    return _lodash2.default.get(row, 'trackedAssetsStats.instagram.igtvs', 0);
  });
  var reelsCount = _lodash2.default.sumBy(values, function (row) {
    return _lodash2.default.get(row, 'trackedAssetsStats.instagram.reels', 0);
  });

  console.log({ reelsCount: reelsCount });
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { columns: 'five', verticalAlign: 'middle', textAlign: 'center', style: generalGridStyle },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { style: columnTypeStyle },
        'Influencers'
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(totalInfluencers)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'total'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(authorisedCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'authorised'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(notAuthorisedCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'not authorised'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(havePostedCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'have posted'
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { style: columnTypeStyle },
        'Content'
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(postsCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'posts'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(storiesCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'stories'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(reelsCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'reels'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(videosCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'videos'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'mini' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            null,
            (0, _formatting.paidReportFormat)(igtvCount)
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            null,
            'IGTVs'
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: prominentRowStyle },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        'CAMPAIGN'
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'small' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            { style: pinkColor },
            (0, _formatting.paidReportFormat)(_lodash2.default.get(totals, 'videoViewsTotal'))
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            { style: pinkColor },
            'views'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'small' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            { style: pinkColor },
            (0, _formatting.paidReportFormat)(_lodash2.default.get(totals, 'reachTotal'))
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            { style: pinkColor },
            'reach'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'small' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            { style: pinkColor },
            (0, _formatting.paidReportFormat)(_lodash2.default.get(totals, 'impressionsTotal'))
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            { style: pinkColor },
            'impressions'
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Statistic,
          { size: 'small' },
          _react2.default.createElement(
            _semanticUiReact.Statistic.Value,
            { style: pinkColor },
            (0, _formatting.paidReportFormat)(_lodash2.default.get(totals, 'engagementsTotal'))
          ),
          _react2.default.createElement(
            _semanticUiReact.Statistic.Label,
            { style: pinkColor },
            'engagements'
          )
        )
      )
    )
  );
};

SummaryTable.propTypes = {
  rows: _propTypes2.default.object.isRequired,
  totals: _propTypes2.default.any.isRequired
};

exports.default = SummaryTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/super-report/summary-table.js
// module id = 2276
// module chunks = 1